export class ToggleDropdown extends CustomEvent {
    /**
     * @param {HTMLElement} dropdownContainer
     */
    constructor(dropdownContainer) {
        super('toggledropdownmenu');
        this.dropdownContainer = dropdownContainer;
    }
}

export class CloseDropdownMenus extends CustomEvent {
    constructor() {
        super('closedropdownmenus');
    }
}
